export const selectTransactionList = ({ transaction }) =>
  transaction.transactions;

export const selectTransaction = ({ transaction }) => transaction.transaction;

export const selectTransactionForm = ({ transaction }) => transaction.form;
